import type { BattleRules, BattleState, Enemy, Hero, HeroStats, Projectile, Structure, Zone } from '../types.ts';

// Generated by `pnpm shapes` (tools/shapes.mjs) from types.ts: do not edit by hand.

/*
 * One hidden class per kind of entity. Heroes, nightmares, projectiles and the rest pick up optional fields
 * in many orders (gear, kits, relics, conditions, plans, conditional spreads), and V8 gives each order its own
 * shape: with dozens of them every `h.x` in the hot loops goes the slow, megamorphic way (a campaign ran
 * twice as slow). Rebuilt here with every field of the interface in one fixed order (absent ones as
 * undefined), each kind shares one shape. Nothing else changes: the hash and snapshots skip undefined fields,
 * no code asks whether a field exists, and fields are cleared with `= undefined`, never `delete` (which drops
 * the object to dictionary mode).
 */

export const shapeHero = (h: Hero): Hero => ({
  id: h.id,
  pid: h.pid,
  grabbed: h.grabbed,
  name: h.name,
  cls: h.cls,
  level: h.level,
  x: h.x,
  y: h.y,
  hp: h.hp,
  stats: h.stats,
  control: h.control,
  dreamBase: h.dreamBase,
  post: h.post,
  profile: h.profile,
  relics: h.relics,
  moveAcc: h.moveAcc,
  path: h.path,
  destX: h.destX,
  destY: h.destY,
  moving: h.moving,
  target: h.target,
  forced: h.forced,
  attackCd: h.attackCd,
  skillCd: h.skillCd,
  overloadCd: h.overloadCd,
  ranks: h.ranks,
  forks: h.forks,
  kit: h.kit,
  glyphs: h.glyphs,
  echo: h.echo,
  stun: h.stun,
  shove: h.shove,
  shoveX: h.shoveX,
  shoveY: h.shoveY,
  shovedAt: h.shovedAt,
  fear: h.fear,
  brave: h.brave,
  curse: h.curse,
  curseBp: h.curseBp,
  sleep: h.sleep,
  wokeAt: h.wokeAt,
  poison: h.poison,
  poisonDmg: h.poisonDmg,
  invuln: h.invuln,
  ward: h.ward,
  wardBp: h.wardBp,
  shield: h.shield,
  shieldTicks: h.shieldTicks,
  shieldBack: h.shieldBack,
  roam: h.roam,
  look: h.look,
  uq: h.uq,
  uqLv: h.uqLv,
  uqForm: h.uqForm,
  aura: h.aura,
  mantleCd: h.mantleCd,
  anchor: h.anchor,
  venge: h.venge,
  turnAt: h.turnAt,
  aegisAmt: h.aegisAmt,
  steelAt: h.steelAt,
  barkOn: h.barkOn,
  medalCall: h.medalCall,
  medalAt: h.medalAt,
  fangChain: h.fangChain,
  flaskN: h.flaskN,
  sureCrit: h.sureCrit,
  mantleUp: h.mantleUp,
  boarCd: h.boarCd,
  undying: h.undying,
  wallPush: h.wallPush,
  courage: h.courage,
  courageGot: h.courageGot,
  rootBy: h.rootBy,
  wolfKills: h.wolfKills,
  crackQ: h.crackQ,
  crackN: h.crackN,
  treeQ: h.treeQ,
  treeN: h.treeN,
  standT: h.standT,
  standTaken: h.standTaken,
  kickAt: h.kickAt,
  kickRun: h.kickRun,
  kickHit: h.kickHit,
  brutalLow: h.brutalLow,
  fearN: h.fearN,
  roarBy: h.roarBy,
  drum: h.drum,
  duelOn: h.duelOn,
  furyHits: h.furyHits,
  spiritN: h.spiritN,
  atoneLeft: h.atoneLeft,
  atoneLen: h.atoneLen,
  atoneKills: h.atoneKills,
  atoneChained: h.atoneChained,
  blessBy: h.blessBy,
  blessKills: h.blessKills,
  stairAt: h.stairAt,
  stoneT: h.stoneT,
  wallBurnt: h.wallBurnt,
  hammerKills: h.hammerKills,
  avatarMax: h.avatarMax,
  uqT: h.uqT,
  mineRun: h.mineRun,
  dripRun: h.dripRun,
  apronT: h.apronT,
  apronBp: h.apronBp,
  apronBy: h.apronBy,
  shots: h.shots,
  shieldTaunt: h.shieldTaunt,
  inspire: h.inspire,
  roar: h.roar,
  rooted: h.rooted,
  held: h.held,
  heldAt: h.heldAt,
  chillN: h.chillN,
  chillAt: h.chillAt,
  sporeAt: h.sporeAt,
  rootBp: h.rootBp,
  rootWardBp: h.rootWardBp,
  renew: h.renew,
  renewBp: h.renewBp,
  bleedOn: h.bleedOn,
  thirstBp: h.thirstBp,
  eagle: h.eagle,
  eagleBase: h.eagleBase,
  keen: h.keen,
  intercede: h.intercede,
  intercedeBp: h.intercedeBp,
  areaBlow: h.areaBlow,
  areaR: h.areaR,
  areaBp: h.areaBp,
  areaHoly: h.areaHoly,
  avatarWardBp: h.avatarWardBp,
  unMark: h.unMark,
  unBroke: h.unBroke,
  unImmune: h.unImmune,
  unSmoke: h.unSmoke,
  unStill: h.unStill,
  hidden: h.hidden,
  hiddenBp: h.hiddenBp,
  choir: h.choir,
  choirBp: h.choirBp,
  atone: h.atone,
  atoneBp: h.atoneBp,
  atoneShared: h.atoneShared,
  blessed: h.blessed,
  blessBp: h.blessBp,
  sacrifice: h.sacrifice,
  sacrificeR: h.sacrificeR,
  sacrificeBp: h.sacrificeBp,
  sacrificeTakenBp: h.sacrificeTakenBp,
  wolf: h.wolf,
  wolfBase: h.wolfBase,
  frenzy: h.frenzy,
  leapAgain: h.leapAgain,
  spin: h.spin,
  bear: h.bear,
  still: h.still,
  base: h.base,
  taunt: h.taunt,
  tauntRadius: h.tauntRadius,
  downTicks: h.downTicks,
  facing: h.facing,
  anim: h.anim,
  animT: h.animT,
  idleTicks: h.idleTicks,
  purifying: h.purifying,
  ai: { mode: h.ai.mode, t: h.ai.t, gx: h.ai.gx, gy: h.ai.gy, at: h.ai.at, rescue: h.ai.rescue },
  usedOnce: h.usedOnce,
  grimUsed: h.grimUsed,
  awakened: h.awakened,
  gearHits: h.gearHits,
  stunHits: h.stunHits,
  turretsPlaced: h.turretsPlaced,
  calm: h.calm,
  revive: h.revive,
  carry: h.carry,
  stillCell: h.stillCell,
  glassT: h.glassT,
  starUntil: h.starUntil,
  pages: h.pages,
  eddaUsed: h.eddaUsed,
  lg: h.lg,
  face: h.face,
  lgAura: h.lgAura,
  lgStill: h.lgStill,
  lgX: h.lgX,
  lgY: h.lgY,
  lgCharge: h.lgCharge,
  lgType: h.lgType,
  lgAt: h.lgAt,
  lgPrey: h.lgPrey,
  lgAreaCrit: h.lgAreaCrit,
  lgWith: h.lgWith,
  lgSprAt: h.lgSprAt,
  light: h.light,
  lightWalk: h.lightWalk,
  lightBy: h.lightBy,
  lightHp: h.lightHp,
  lightPow: h.lightPow,
  lightAt: h.lightAt,
  hurtTick: h.hurtTick,
  ax: h.ax,
  ay: h.ay,
});

export const shapeEnemy = (e: Enemy): Enemy => ({
  id: e.id,
  _cell: e._cell,
  _cx: e._cx,
  _cy: e._cy,
  room: e.room,
  scared: e.scared,
  kind: e.kind,
  tier: e.tier,
  elite: e.elite,
  x: e.x,
  y: e.y,
  hp: e.hp,
  maxHp: e.maxHp,
  speed: e.speed,
  damage: e.damage,
  reload: e.reload,
  cd: e.cd,
  sector: e.sector,
  lane: e.lane,
  next: e.next,
  rally: e.rally,
  spot: e.spot,
  squad: e.squad,
  leg: e.leg,
  moveAcc: e.moveAcc,
  tgtKind: e.tgtKind,
  tgtId: e.tgtId,
  stun: e.stun,
  slowBp: e.slowBp,
  acidTicks: e.acidTicks,
  grounded: e.grounded,
  air: e.air,
  orbit: e.orbit,
  dry: e.dry,
  slowTicks: e.slowTicks,
  dotDmg: e.dotDmg,
  dotEvery: e.dotEvery,
  dotTicks: e.dotTicks,
  dotType: e.dotType,
  markTicks: e.markTicks,
  markBy: e.markBy,
  emberBy: e.emberBy,
  emberDmg: e.emberDmg,
  pinUntil: e.pinUntil,
  pinBy: e.pinBy,
  pinCd: e.pinCd,
  limeUntil: e.limeUntil,
  drowse: e.drowse,
  drowseUntil: e.drowseUntil,
  lureBot: e.lureBot,
  lureUntil: e.lureUntil,
  dreamBy: e.dreamBy,
  dripBy: e.dripBy,
  dripDmg: e.dripDmg,
  uqGen: e.uqGen,
  jailBy: e.jailBy,
  markJumps: e.markJumps,
  markHop: e.markHop,
  uqE: e.uqE,
  guardOff: e.guardOff,
  briarBy: e.briarBy,
  briarUntil: e.briarUntil,
  rawBp: e.rawBp,
  rawUntil: e.rawUntil,
  crackBy: e.crackBy,
  holdAt: e.holdAt,
  treeBy: e.treeBy,
  kickBy: e.kickBy,
  kickUntil: e.kickUntil,
  fearBy: e.fearBy,
  fearUntil: e.fearUntil,
  fearGen: e.fearGen,
  duelPass: e.duelPass,
  duelWins: e.duelWins,
  sealBy: e.sealBy,
  sealHit: e.sealHit,
  hushUntil: e.hushUntil,
  markBp: e.markBp,
  seedFrom: e.seedFrom,
  seedAt: e.seedAt,
  wasps: e.wasps,
  chill: e.chill,
  brittle: e.brittle,
  encases: e.encases,
  echo: e.echo,
  owner: e.owner,
  blind: e.blind,
  blindBp: e.blindBp,
  gateAt: e.gateAt,
  holyT: e.holyT,
  hugAt: e.hugAt,
  tangleAt: e.tangleAt,
  rootBy: e.rootBy,
  rootT: e.rootT,
  seal: e.seal,
  sealBp: e.sealBp,
  sealBurn: e.sealBurn,
  linkId: e.linkId,
  linkTicks: e.linkTicks,
  linkBp: e.linkBp,
  duelBy: e.duelBy,
  duelTicks: e.duelTicks,
  duelLeechBp: e.duelLeechBp,
  lastHit: e.lastHit,
  regenAcc: e.regenAcc,
  taunter: e.taunter,
  tauntTicks: e.tauntTicks,
  split: e.split,
  digX: e.digX,
  digY: e.digY,
  phase: e.phase,
  timer: e.timer,
  cracked: e.cracked,
  shellWear: e.shellWear,
  raised: e.raised,
  inspired: e.inspired,
  rallied: e.rallied,
  ward: e.ward,
  ash: e.ash,
  scorch: e.scorch,
  panic: e.panic,
  calm: e.calm,
  bashAt: e.bashAt,
  dropped: e.dropped,
  blinkAt: e.blinkAt,
  openUntil: e.openUntil,
  shineUntil: e.shineUntil,
  facing: e.facing,
  anim: e.anim,
  animT: e.animT,
  lastPid: e.lastPid,
  born: e.born,
  trapCell: e.trapCell,
  leaked: e.leaked,
  un: e.un,
  fled: e.fled,
  grab: e.grab,
  cut: e.cut,
  mask: e.mask,
  lgTr: e.lgTr,
  lgTrAt: e.lgTrAt,
  lgVuln: e.lgVuln,
});

export const shapeStats = (x: HeroStats): HeroStats => ({
  maxHp: x.maxHp,
  attack: x.attack,
  reload: x.reload,
  range: x.range,
  splash: x.splash,
  armorBp: x.armorBp,
  speed: x.speed,
  powerBp: x.powerBp,
  damageBp: x.damageBp,
  cooldownBp: x.cooldownBp,
  healBp: x.healBp,
  blockCapacity: x.blockCapacity,
  critBp: x.critBp,
  critMultBp: x.critMultBp,
  resBp: x.resBp,
  melee: x.melee,
  bigFoeBp: x.bigFoeBp,
  mendBp: x.mendBp,
  shun: x.shun,
  stunEvery: x.stunEvery,
  stunTicks: x.stunTicks,
  pierceGear: x.pierceGear,
  blockBp: x.blockBp,
  skillBp: x.skillBp,
  summonBp: x.summonBp,
  burnBp: x.burnBp,
  lifestealBp: x.lifestealBp,
  thornsBp: x.thornsBp,
  furyGearBp: x.furyGearBp,
  executeBp: x.executeBp,
  chainBp: x.chainBp,
  frostBp: x.frostBp,
  cleaveBp: x.cleaveBp,
  guardBp: x.guardBp,
  echoTicks: x.echoTicks,
  bannerBp: x.bannerBp,
});

export const shapeProjectile = (p: Projectile): Projectile => ({
  dt: p.dt,
  id: p.id,
  kind: p.kind,
  x: p.x,
  y: p.y,
  sx: p.sx,
  sy: p.sy,
  tx: p.tx,
  ty: p.ty,
  target: p.target,
  speed: p.speed,
  damage: p.damage,
  splash: p.splash,
  ignoresArmor: p.ignoresArmor,
  pierce: p.pierce,
  enchant: p.enchant,
  stun: p.stun,
  hardStun: p.hardStun,
  flight: p.flight,
  t: p.t,
  pid: p.pid,
  hero: p.hero,
  crit: p.crit,
  uq: p.uq,
  hostile: p.hostile,
  flee: p.flee,
});

export const shapeStructure = (st: Structure): Structure => ({
  id: st.id,
  type: st.type,
  level: st.level,
  material: st.material,
  q: st.q,
  r: st.r,
  hp: st.hp,
  pathHp: st.pathHp,
  maxHp: st.maxHp,
  cd: st.cd,
  charges: st.charges,
  enchant: st.enchant,
  fortified: st.fortified,
  cursed: st.cursed,
  purify: st.purify,
  aim: st.aim,
  buffTicks: st.buffTicks,
  buffBp: st.buffBp,
  destroyed: st.destroyed,
  cellKey: st.cellKey,
  foot: st.foot,
  shield: st.shield,
  shieldTicks: st.shieldTicks,
  shieldBack: st.shieldBack,
  burnTicks: st.burnTicks,
  burnDmg: st.burnDmg,
  cocoon: st.cocoon,
  brittleUntil: st.brittleUntil,
  dozeUntil: st.dozeUntil,
  turnedUntil: st.turnedUntil,
  branch: st.branch,
  mount: st.mount,
  charge: st.charge,
  burnZone: st.burnZone,
  cold: st.cold,
  frostCd: st.frostCd,
  lit: st.lit,
  tunedUntil: st.tunedUntil,
  tunedBp: st.tunedBp,
  holdUntil: st.holdUntil,
  mended: st.mended,
  roll: st.roll,
  shots: st.shots,
});

export const shapeZone = (z: Zone): Zone => ({
  dt: z.dt,
  id: z.id,
  kind: z.kind,
  x: z.x,
  y: z.y,
  radius: z.radius,
  cells: z.cells,
  ticks: z.ticks,
  every: z.every,
  damage: z.damage,
  slowBp: z.slowBp,
  pid: z.pid,
  heal: z.heal,
  wardBp: z.wardBp,
  warn: z.warn,
  ail: z.ail,
  phase: z.phase,
  follow: z.follow,
  haz: z.haz,
  room: z.room,
  tx: z.tx,
  ty: z.ty,
  reveal: z.reveal,
  vx: z.vx,
  vy: z.vy,
  steps: z.steps,
  burst: z.burst,
  pulses: z.pulses,
  stunEvery: z.stunEvery,
  stun: z.stun,
  strike: z.strike,
  steady: z.steady,
  coverBp: z.coverBp,
  burns: z.burns,
  blast: z.blast,
  arcs: z.arcs,
  bleed: z.bleed,
  un: z.un,
  hpBp: z.hpBp,
  towerBp: z.towerBp,
  fm: z.fm,
  uqz: z.uqz,
  uqh: z.uqh,
  seen: z.seen,
  uqT: z.uqT,
  fe: z.fe,
  hit: z.hit,
  kills: z.kills,
  still: z.still,
  hop: z.hop,
  uqIds: z.uqIds,
  uq: z.uq,
  uqn: z.uqn,
});

export const shapeBattle = (b: BattleState): BattleState => ({
  v: b.v,
  mode: b.mode,
  tick: b.tick,
  seed: b.seed,
  rng: b.rng,
  nextId: b.nextId,
  map: b.map,
  gridRev: b.gridRev,
  pathRev: b.pathRev,
  structures: b.structures,
  turrets: b.turrets,
  bots: b.bots,
  lg: b.lg,
  heroes: b.heroes,
  enemies: b.enemies,
  projectiles: b.projectiles,
  zones: b.zones,
  uqDue: b.uqDue,
  keep: b.keep,
  keepShield: b.keepShield,
  keepShieldTicks: b.keepShieldTicks,
  wave: b.wave,
  objective: b.objective,
  rules: b.rules,
  season: b.season,
  drums: b.drums,
  dungeon: b.dungeon,
  bossId: b.bossId,
  un: b.un,
  rescue: b.rescue,
  herd: b.herd,
  alone: b.alone,
  anvil: b.anvil,
  bells: b.bells,
  maw: b.maw,
  fin: b.fin,
  neck: b.neck,
  climb: b.climb,
  winch: b.winch,
  copies: b.copies,
  allies: b.allies,
  senda: b.senda,
  plugs: b.plugs,
  toll: b.toll,
  sunken: b.sunken,
  tide: b.tide,
  fair: b.fair,
  drink: b.drink,
  well: b.well,
  rising: b.rising,
  rails: b.rails,
  rifts: b.rifts,
  blast: b.blast,
  trap: b.trap,
  collapse: b.collapse,
  lash: b.lash,
  hunt: b.hunt,
  dragon: b.dragon,
  call: b.call,
  crowd: b.crowd,
  clues: b.clues,
  burst: b.burst,
  plan: b.plan,
  escort: b.escort,
  plunder: b.plunder,
  purse: b.purse,
  started: b.started,
  waveT: b.waveT,
  result: b.result,
  endTick: b.endTick,
  stats: b.stats,
  _events: b._events,
  _cache: b._cache,
});

export const shapeRules = (r: BattleRules): BattleRules => ({
  rifts: r.rifts,
  dreamBeacon: r.dreamBeacon,
  spectres: r.spectres,
  escort: r.escort,
  bossWins: r.bossWins,
  rush: r.rush,
  enemySpeedBp: r.enemySpeedBp,
  enemyHpBp: r.enemyHpBp,
  eliteHpBp: r.eliteHpBp,
  heroRangeBp: r.heroRangeBp,
  enemyDamageBp: r.enemyDamageBp,
  heroLifestealBp: r.heroLifestealBp,
  bolts: r.bolts,
  towerRangeBp: r.towerRangeBp,
  skyBolts: r.skyBolts,
  towerReloadBp: r.towerReloadBp,
  warmRange: r.warmRange,
  stars: r.stars,
  dragon: r.dragon,
  turrets: r.turrets,
  clearToFinish: r.clearToFinish,
  keepFrailBp: r.keepFrailBp,
  towerDamageBp: r.towerDamageBp,
  structureTakenBp: r.structureTakenBp,
  props: r.props,
  builtBp: r.builtBp,
  tier: r.tier,
  mission: r.mission,
  dark: r.dark,
  burst: r.burst,
  twist: r.twist,
  omen: r.omen,
  unscathed: r.unscathed,
  alone: r.alone,
  beside: r.beside,
  anvil: r.anvil,
  bells: r.bells,
  rails: r.rails,
  maw: r.maw,
  fin: r.fin,
  sunken: r.sunken,
  tide: r.tide,
  drowned: r.drowned,
  fair: r.fair,
  drinker: r.drinker,
  well: r.well,
  rising: r.rising,
  bet: r.bet,
  race: r.race,
  neck: r.neck,
  climb: r.climb,
  winch: r.winch,
  copies: r.copies,
  allies: r.allies,
  toll: r.toll,
  openGate: r.openGate,
  place: r.place,
  night: r.night,
  crowd: r.crowd,
  rescue: r.rescue,
  herd: r.herd,
  blast: r.blast,
  trap: r.trap,
  collapse: r.collapse,
  lash: r.lash,
  hunt: r.hunt,
  call: r.call,
  lanterns: r.lanterns,
  clues: r.clues,
  risk: r.risk,
  senda: r.senda,
  memory: r.memory,
});

/** The fields each shape lists (in types.ts order). */
export const SHAPE_KEYS: Record<string, readonly string[]> = {
  Hero: ['id', 'pid', 'grabbed', 'name', 'cls', 'level', 'x', 'y', 'hp', 'stats', 'control', 'dreamBase', 'post', 'profile', 'relics', 'moveAcc', 'path', 'destX', 'destY', 'moving', 'target', 'forced', 'attackCd', 'skillCd', 'overloadCd', 'ranks', 'forks', 'kit', 'glyphs', 'echo', 'stun', 'shove', 'shoveX', 'shoveY', 'shovedAt', 'fear', 'brave', 'curse', 'curseBp', 'sleep', 'wokeAt', 'poison', 'poisonDmg', 'invuln', 'ward', 'wardBp', 'shield', 'shieldTicks', 'shieldBack', 'roam', 'look', 'uq', 'uqLv', 'uqForm', 'aura', 'mantleCd', 'anchor', 'venge', 'turnAt', 'aegisAmt', 'steelAt', 'barkOn', 'medalCall', 'medalAt', 'fangChain', 'flaskN', 'sureCrit', 'mantleUp', 'boarCd', 'undying', 'wallPush', 'courage', 'courageGot', 'rootBy', 'wolfKills', 'crackQ', 'crackN', 'treeQ', 'treeN', 'standT', 'standTaken', 'kickAt', 'kickRun', 'kickHit', 'brutalLow', 'fearN', 'roarBy', 'drum', 'duelOn', 'furyHits', 'spiritN', 'atoneLeft', 'atoneLen', 'atoneKills', 'atoneChained', 'blessBy', 'blessKills', 'stairAt', 'stoneT', 'wallBurnt', 'hammerKills', 'avatarMax', 'uqT', 'mineRun', 'dripRun', 'apronT', 'apronBp', 'apronBy', 'shots', 'shieldTaunt', 'inspire', 'roar', 'rooted', 'held', 'heldAt', 'chillN', 'chillAt', 'sporeAt', 'rootBp', 'rootWardBp', 'renew', 'renewBp', 'bleedOn', 'thirstBp', 'eagle', 'eagleBase', 'keen', 'intercede', 'intercedeBp', 'areaBlow', 'areaR', 'areaBp', 'areaHoly', 'avatarWardBp', 'unMark', 'unBroke', 'unImmune', 'unSmoke', 'unStill', 'hidden', 'hiddenBp', 'choir', 'choirBp', 'atone', 'atoneBp', 'atoneShared', 'blessed', 'blessBp', 'sacrifice', 'sacrificeR', 'sacrificeBp', 'sacrificeTakenBp', 'wolf', 'wolfBase', 'frenzy', 'leapAgain', 'spin', 'bear', 'still', 'base', 'taunt', 'tauntRadius', 'downTicks', 'facing', 'anim', 'animT', 'idleTicks', 'purifying', 'ai', 'usedOnce', 'grimUsed', 'awakened', 'gearHits', 'stunHits', 'turretsPlaced', 'calm', 'revive', 'carry', 'stillCell', 'glassT', 'starUntil', 'pages', 'eddaUsed', 'lg', 'face', 'lgAura', 'lgStill', 'lgX', 'lgY', 'lgCharge', 'lgType', 'lgAt', 'lgPrey', 'lgAreaCrit', 'lgWith', 'lgSprAt', 'light', 'lightWalk', 'lightBy', 'lightHp', 'lightPow', 'lightAt', 'hurtTick', 'ax', 'ay'],
  Enemy: ['id', '_cell', '_cx', '_cy', 'room', 'scared', 'kind', 'tier', 'elite', 'x', 'y', 'hp', 'maxHp', 'speed', 'damage', 'reload', 'cd', 'sector', 'lane', 'next', 'rally', 'spot', 'squad', 'leg', 'moveAcc', 'tgtKind', 'tgtId', 'stun', 'slowBp', 'acidTicks', 'grounded', 'air', 'orbit', 'dry', 'slowTicks', 'dotDmg', 'dotEvery', 'dotTicks', 'dotType', 'markTicks', 'markBy', 'emberBy', 'emberDmg', 'pinUntil', 'pinBy', 'pinCd', 'limeUntil', 'drowse', 'drowseUntil', 'lureBot', 'lureUntil', 'dreamBy', 'dripBy', 'dripDmg', 'uqGen', 'jailBy', 'markJumps', 'markHop', 'uqE', 'guardOff', 'briarBy', 'briarUntil', 'rawBp', 'rawUntil', 'crackBy', 'holdAt', 'treeBy', 'kickBy', 'kickUntil', 'fearBy', 'fearUntil', 'fearGen', 'duelPass', 'duelWins', 'sealBy', 'sealHit', 'hushUntil', 'markBp', 'seedFrom', 'seedAt', 'wasps', 'chill', 'brittle', 'encases', 'echo', 'owner', 'blind', 'blindBp', 'gateAt', 'holyT', 'hugAt', 'tangleAt', 'rootBy', 'rootT', 'seal', 'sealBp', 'sealBurn', 'linkId', 'linkTicks', 'linkBp', 'duelBy', 'duelTicks', 'duelLeechBp', 'lastHit', 'regenAcc', 'taunter', 'tauntTicks', 'split', 'digX', 'digY', 'phase', 'timer', 'cracked', 'shellWear', 'raised', 'inspired', 'rallied', 'ward', 'ash', 'scorch', 'panic', 'calm', 'bashAt', 'dropped', 'blinkAt', 'openUntil', 'shineUntil', 'facing', 'anim', 'animT', 'lastPid', 'born', 'trapCell', 'leaked', 'un', 'fled', 'grab', 'cut', 'mask', 'lgTr', 'lgTrAt', 'lgVuln'],
  HeroStats: ['maxHp', 'attack', 'reload', 'range', 'splash', 'armorBp', 'speed', 'powerBp', 'damageBp', 'cooldownBp', 'healBp', 'blockCapacity', 'critBp', 'critMultBp', 'resBp', 'melee', 'bigFoeBp', 'mendBp', 'shun', 'stunEvery', 'stunTicks', 'pierceGear', 'blockBp', 'skillBp', 'summonBp', 'burnBp', 'lifestealBp', 'thornsBp', 'furyGearBp', 'executeBp', 'chainBp', 'frostBp', 'cleaveBp', 'guardBp', 'echoTicks', 'bannerBp'],
  Projectile: ['dt', 'id', 'kind', 'x', 'y', 'sx', 'sy', 'tx', 'ty', 'target', 'speed', 'damage', 'splash', 'ignoresArmor', 'pierce', 'enchant', 'stun', 'hardStun', 'flight', 't', 'pid', 'hero', 'crit', 'uq', 'hostile', 'flee'],
  Structure: ['id', 'type', 'level', 'material', 'q', 'r', 'hp', 'pathHp', 'maxHp', 'cd', 'charges', 'enchant', 'fortified', 'cursed', 'purify', 'aim', 'buffTicks', 'buffBp', 'destroyed', 'cellKey', 'foot', 'shield', 'shieldTicks', 'shieldBack', 'burnTicks', 'burnDmg', 'cocoon', 'brittleUntil', 'dozeUntil', 'turnedUntil', 'branch', 'mount', 'charge', 'burnZone', 'cold', 'frostCd', 'lit', 'tunedUntil', 'tunedBp', 'holdUntil', 'mended', 'roll', 'shots'],
  Zone: ['dt', 'id', 'kind', 'x', 'y', 'radius', 'cells', 'ticks', 'every', 'damage', 'slowBp', 'pid', 'heal', 'wardBp', 'warn', 'ail', 'phase', 'follow', 'haz', 'room', 'tx', 'ty', 'reveal', 'vx', 'vy', 'steps', 'burst', 'pulses', 'stunEvery', 'stun', 'strike', 'steady', 'coverBp', 'burns', 'blast', 'arcs', 'bleed', 'un', 'hpBp', 'towerBp', 'fm', 'uqz', 'uqh', 'seen', 'uqT', 'fe', 'hit', 'kills', 'still', 'hop', 'uqIds', 'uq', 'uqn'],
  BattleState: ['v', 'mode', 'tick', 'seed', 'rng', 'nextId', 'map', 'gridRev', 'pathRev', 'structures', 'turrets', 'bots', 'lg', 'heroes', 'enemies', 'projectiles', 'zones', 'uqDue', 'keep', 'keepShield', 'keepShieldTicks', 'wave', 'objective', 'rules', 'season', 'drums', 'dungeon', 'bossId', 'un', 'rescue', 'herd', 'alone', 'anvil', 'bells', 'maw', 'fin', 'neck', 'climb', 'winch', 'copies', 'allies', 'senda', 'plugs', 'toll', 'sunken', 'tide', 'fair', 'drink', 'well', 'rising', 'rails', 'rifts', 'blast', 'trap', 'collapse', 'lash', 'hunt', 'dragon', 'call', 'crowd', 'clues', 'burst', 'plan', 'escort', 'plunder', 'purse', 'started', 'waveT', 'result', 'endTick', 'stats', '_events', '_cache'],
  BattleRules: ['rifts', 'dreamBeacon', 'spectres', 'escort', 'bossWins', 'rush', 'enemySpeedBp', 'enemyHpBp', 'eliteHpBp', 'heroRangeBp', 'enemyDamageBp', 'heroLifestealBp', 'bolts', 'towerRangeBp', 'skyBolts', 'towerReloadBp', 'warmRange', 'stars', 'dragon', 'turrets', 'clearToFinish', 'keepFrailBp', 'towerDamageBp', 'structureTakenBp', 'props', 'builtBp', 'tier', 'mission', 'dark', 'burst', 'twist', 'omen', 'unscathed', 'alone', 'beside', 'anvil', 'bells', 'rails', 'maw', 'fin', 'sunken', 'tide', 'drowned', 'fair', 'drinker', 'well', 'rising', 'bet', 'race', 'neck', 'climb', 'winch', 'copies', 'allies', 'toll', 'openGate', 'place', 'night', 'crowd', 'rescue', 'herd', 'blast', 'trap', 'collapse', 'lash', 'hunt', 'call', 'lanterns', 'clues', 'risk', 'senda', 'memory'],
};
